import { Component } from '@angular/core';
import { ZoomButtonsComponent } from './zoom-buttons/zoom-buttons.component';
import { MapControlButtonsComponent } from './map-control-buttons/map-control-buttons.component';
import { LoaderComponent } from './loader/loader.component';

@Component({
  selector: 'app-overlay',
  standalone: true,
  imports: [
    MapControlButtonsComponent,
    LoaderComponent,
    ZoomButtonsComponent
  ],
  templateUrl: './overlay.component.html',
  styleUrl: './overlay.component.css'
})
export class OverlayComponent {

}
